import { render, staticRenderFns } from "./WebPartnerList.vue?vue&type=template&id=7661ae6b&scoped=true&"
import script from "./WebPartnerList.vue?vue&type=script&lang=js&"
export * from "./WebPartnerList.vue?vue&type=script&lang=js&"
import style0 from "./WebPartnerList.vue?vue&type=style&index=0&id=7661ae6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7661ae6b",
  null
  
)

export default component.exports